import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
// import { unauthorizedError } from '../../../utils/helpers';
import jobService from '../../../services/api/Organization/JobService';
import { setUserProfile } from '../../Global/globalSlice';
import { get_organization_jobs, setChangesStatus } from '../OrganizationInfo/OrganizationInfoSlice';
import { get_organization } from '../OrgAuth/OrgAuthSlice';

const jobservice = new jobService();
// export const create_job = createAsyncThunk(
//     "job/create_job",
//     async ({ body, navigate, onClose, isBoost = false, hasToken = "", latestToken = {} }, { dispatch }) => {
//         console.log("hastoken", hasToken, isBoost,)
//         dispatch(setCreateJobLoad(true))
//         try {
//             const response = await jobservice.create_jobs(body)
//             if (isBoost) {
//                 if (hasToken && latestToken?.balance > 0) {
//                     dispatch(setIsBoostPopup(true)); 
//                 } else {
//                     dispatch(setIsTokenOpen(true)); 
//                 }
//             }
//             dispatch(setCreateJobLoad(false))
//             dispatch(setStoreJobIdForBoostJob(response?.data))
//             onClose()
//             dispatch(get_organization(navigate))
//             dispatch(setChangesStatus(body?.status))
//             dispatch(get_organization_jobs({ navigate: navigate, searchParams: "", status: body?.status }))
//             message.success("Job created SucessFully")
//             return response.data
//         } catch (error) {
//             dispatch(setCreateJobLoad(false))
//             if (error?.response && error?.response?.status === 401) {
//                 dispatch(setUserProfile({}))
//                 unauthorizedError(navigate)
//             } else {
//                 dispatch(setCreateJobLoad(false))
//                 error?.response?.data?.error && message.error(error?.response?.data?.error)
//                 const [{ msg }] = error.response.data;
//                 message.error(msg);
//             }
//         }
//     }
// );

export const create_job = createAsyncThunk(
    "job/create_job",
    async ({ body, navigate, onClose, isBoost = false, hasToken = false, latestToken = null }, { dispatch }) => {
        dispatch(setCreateJobLoad(true));

        try {
            const response = await jobservice.create_jobs(body);

            dispatch(setCreateJobLoad(false));
            dispatch(setStoreJobIdForBoostJob(response?.data));
            onClose();


            dispatch(get_organization(navigate));
            dispatch(setChangesStatus(body?.status));
            dispatch(get_organization_jobs({ navigate, searchParams: "", status: body?.status }));
            message.success("Job created SucessFully");

            if (isBoost) {
                const validBalance = latestToken && typeof latestToken.balance === 'number' && latestToken.balance > 0;

                if (hasToken && validBalance) {
                    dispatch(setIsBoostPopup(true));
                } else {
                    dispatch(setIsTokenOpen(true));
                }
            }

            return response.data;

        } catch (error) {
            dispatch(setCreateJobLoad(false));
            // if (error?.response?.status === 401) {
            //     dispatch(setUserProfile({}));
            //     unauthorizedError(navigate);
            // } else {
                const [{ msg }] = error?.response?.data || [{}];
                if (msg) message.error(msg);
                else message.error("Something went wrong");
            // }
        }
    }
);



export const upload_job = createAsyncThunk(
    "job/upload_job",
    async ({ body, navigate, onClose }, { dispatch }) => {
        dispatch(setUploadJobLoad(true))
        try {
            const response = await jobservice.Upload_jobs(body)
            const { data } = response;
            dispatch(setUploadJobLoad(false))
            onClose()
            message.success("Job uploaded SucessFully")
            return response.data
        } catch (error) {
            dispatch(setUploadJobLoad(false))
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setUploadJobLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data;
                message.error(msg);
            // }
        }
    }
);

const initialState = {
    createJobLoad: false,
    uploadJobLoad: false,
    storeJobIdForBoostJob: false,
    isBoosting: false,
    isPaymentProcessingStart: false,
    isPricingShow: false,
    isTokenOpen: false,
    isBoostpopup: false,
    orderDetails:{},
    isRedirectingToPaymentCheckoutPage: false,
};

const jobAuthSlice = createSlice({
    name: 'jobs',
    initialState,
    reducers: {
        setCreateJobLoad: (state, action) => {
            state.createJobLoad = action.payload
        },
        setUploadJobLoad: (state, action) => {
            state.uploadJobLoad = action.payload
        },
        setStoreJobIdForBoostJob: (state, action) => {
            state.storeJobIdForBoostJob = action.payload
        },
        setIsBoosting: (state, action) => {
            state.isBoosting = action.payload
        },
        setIsPaymentProcessingStart: (state, action) => {
            state.isPaymentProcessingStart = action.payload
        },
        setIsPricingShow: (state, action) => {
            state.isPricingShow = action.payload
        },
        setIsTokenOpen: (state, action) => {
            state.isTokenOpen = action.payload
        },
        setIsBoostPopup: (state, action) => {
            state.isBoostpopup = action.payload
        },
        setIsRedirectingToPaymentCheckoutPage: (state, action) => {
            state.isRedirectingToPayment = action.payload;
        },
        setOrderDetails:(state , action)=>{
            state.orderDetails = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(create_job.pending, (state, action) => {
            state.loading = true;
        })
            .addCase(create_job.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
            })
            .addCase(create_job.rejected, (state, action) => {
                state.user = action.payload;
                state.loading = false;
            })

            .addCase(upload_job.pending, (state, action) => {
                state.loading = false;
            })
            .addCase(upload_job.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(upload_job.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export const
    { setCreateJobLoad, setUploadJobLoad, setStoreJobIdForBoostJob, setIsBoosting, setIsPaymentProcessingStart,
        setIsPricingShow, setIsTokenOpen, setIsBoostPopup ,setIsRedirectingToPaymentCheckoutPage , setOrderDetails
    } = jobAuthSlice.actions;
export default jobAuthSlice.reducer;
